export default "__VITE_ASSET__DjW68J8m__"